import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class Recepcion { 
  id_orden:string;
  batch:string;
  usuario:string;
  id_producto:string;
  producto:string;
  product_value:string;
  cod_asociacion:string;
  asociacion:string;
  cantidad:string;
  

}
